<form [formGroup]="form">
  <div class="p-fluid grid">
    <div class="field col-12 flex flex-column">
      <label class="font-semibold"> Tipo de Mídia </label>

      <p-select
        formControlName="tipo"
        [options]="tipos"
        optionLabel="label"
        optionValue="value"
      >
      </p-select>
    </div>

    <div class="field col-12 flex flex-column">
      <label class="font-semibold"> Descrição </label>

      <input pInputText formControlName="descricao" />
    </div>

    <div class="col-12">
      <label class="font-semibold"> Origem </label>

      <div class="flex gap-4 mt-2">
        <p-radioButton name="origem" value="arquivo" formControlName="origem">
        </p-radioButton>

        <span>Arquivo</span>

        <p-radioButton name="origem" value="url" formControlName="origem">
        </p-radioButton>

        <span>URL</span>
      </div>
    </div>

    <div class="field col-12 flex flex-column" *ngIf="origem === 'url'">
      <label class="font-semibold"> URL </label>

      <input pInputText formControlName="url" placeholder="https://" />
    </div>

    <div class="field col-12 flex flex-column" *ngIf="origem === 'arquivo'">
      <label class="font-semibold block mb-2"> Arquivo </label>

      <p-fileUpload
        #fu
        mode="basic"
        chooseLabel="Selecionar Arquivo"
        [customUpload]="true"
        [auto]="false"
        [multiple]="false"
        [maxFileSize]="50000000"
        accept=".pdf,.png,.jpg,.jpeg,.gif,.mp4,.mkv"
        (onSelect)="onFileSelect($event)"
        (onClear)="onFileClear()"
      >
      </p-fileUpload>

      <small *ngIf="fileSelecionado" class="block mt-2 text-green-500">
        {{ fileSelecionado.name }}
      </small>

      <small class="block mt-1 text-500">
        Formatos permitidos: PDF, PNG, JPG, JPEG, GIF, MP4 e MKV
      </small>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="flex justify-content-end gap-2">
    <button
      pButton
      type="button"
      label="Cancelar"
      severity="secondary"
      (click)="cancelar()"
    ></button>

    <button pButton type="button" label="Salvar" (click)="salvar()"></button>
  </div>
</form>